(function () {
  function normalize(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function formatRating(format, rating, count) {
    return (format || "{rating} ({count} Bewertungen)")
      .replace("{rating}", rating || "")
      .replace("{count}", count || "");
  }

  function extractRating(root) {
    var header = root.querySelector(".Products_reviews .header_reviews_number, .header_reviews_number");
    var text = normalize(header && header.textContent);
    var match = text.match(/(\d+(?:[,.]\d+)?)\s*\(\s*([0-9.]+)\s*Bewertungen/i);
    if (match) return { rating: match[1].replace(",", "."), count: match[2].replace(/\./g, "") };

    var total = root.querySelector(".AreviewsTotalNumber");
    var count = normalize(total && total.textContent).replace(/\./g, "");
    if (count) return { rating: "", count: count };

    return null;
  }

  function updateBadge(badge, data) {
    if (!badge || !data) return;
    var format = badge.getAttribute("data-rating-format");
    var fallbackRating = badge.getAttribute("data-fallback-rating");
    var fallbackCount = badge.getAttribute("data-fallback-count");
    var rating = data.rating || fallbackRating;
    var count = data.count || fallbackCount;
    var text = formatRating(format, rating, count);
    var textEl = badge.querySelector("[data-areviews-rating-text]");
    if (textEl) textEl.textContent = text;
    badge.setAttribute("aria-label", text + " - Kundenbewertungen ansehen");
  }

  function hydrateBadge(badge) {
    var productId = badge.getAttribute("data-product-id");
    if (!productId || badge.getAttribute("data-live-fetch") !== "true" || !window.fetch) return;

    var params = new URLSearchParams();
    params.set("product_id", productId);
    params.set("customer_id", window.customer_id || "");
    params.set("customer_country", "");

    fetch("/apps/aliexpress_reviews", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
      body: params.toString(),
      credentials: "same-origin",
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        updateBadge(badge, extractRating(doc));
      })
      .catch(function () {});
  }

  function bindBadge(badge) {
    if (!badge || badge.dataset.areviewsRatingBound) return;
    badge.dataset.areviewsRatingBound = "true";

    badge.addEventListener("click", function (event) {
      if (badge.getAttribute("data-clickable") !== "true") return;
      var target = document.querySelector(badge.getAttribute("data-scroll-target") || "#az_reviews");
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    hydrateBadge(badge);
  }

  function init() {
    document.querySelectorAll("[data-areviews-rating-fetcher]").forEach(bindBadge);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
